import React from "react";
import { View, Platform, StyleSheet, ScrollView, Text } from "react-native";

import Header from "../../../common/header/index";
import appStyles from "../../../../appStyles";
import appPages from "../../../../../appPages";
import AppTheme from "../../../AppTheme";
import { MoodColors } from "../../../common/mood/MoodsHelper";
import { INTEGRATION_KEYS } from "../../IntegrationsHelper";
import ManaButton from "../../../common/ManaButton";
import { isAppleDevice } from "../../../../../helpers/utils";

export default function Reconnect({
  goBack = () => {},
  saveIntegrations = () => {},
}) {
  return (
    <View style={[appStyles.container, { backgroundColor: "#FFF" }]}>
      <Header
        title="Apple Health"
        subTitle="Customize attributes to share"
        goBack={goBack}
        returnPage={appPages.integrationsV2}
      />

      <ScrollView
        style={(appStyles.scrollView, { paddingHorizontal: 16 })}
        contentContainerStyle={appStyles.scrollViewContent}
      >
        <View
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 15,
          }}
        >
          {isAppleDevice ? (
            <>
              <Text style={styles.warning}>
                We’re having trouble connecting to your account
              </Text>

              <ManaButton
                isMainButton
                onPress={() =>
                  saveIntegrations({
                    [INTEGRATION_KEYS.health]: true
                  })
                }
                text="Reconnect"
                style={styles.button}
                styleText={styles.buttonText}
              />
            </>
          ) : null}
        </View>

        <Text style={[styles.text, { fontWeight: "600" }]}>
          On your iOS device,
        </Text>

        <Text style={styles.text}>
          Go to Health, Data Access & Devices, Mana.
        </Text>
        <Text style={styles.text}>
          Turn on all categories you want to track.
        </Text>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  warning: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: MoodColors.VeryBad,
  },
  text: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  button: {
    width: 215,
    height: 32,
    marginVertical: 16,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
});
